import React from 'react';
import type { DataTableColumn, DataTableRenderCellParams } from '@/components/custom/erp/data-table-v2';
import { CellFieldV2 as CellField } from '@/components/custom/erp';
import { ChiTietDieuKienThanhToan } from '@/types/schemas';

export const getInvoiceCollectionColumns = (
  onCellValueChange: (rowUuid: string, field: string, newValue: BanHangValue) => void
): DataTableColumn[] => [
  {
    field: 'ngay_gom_hd1',
    headerName: 'Ngày gom hóa đơn từ',
    width: 200,
    renderCell: (params: DataTableRenderCellParams<ChiTietDieuKienThanhToan>) => (
      <CellField
        name='ngay_gom_hd1'
        type='number'
        value={params.row.ngay_gom_hd1}
        onValueChange={(newValue: BanHangValue) =>
          params.row.uuid && onCellValueChange(params.row.uuid, 'ngay_gom_hd1', newValue)
        }
        commitOnBlur
      />
    )
  },
  {
    field: 'ngay_gom_hd2',
    headerName: 'Ngày gom hóa đơn đến',
    width: 200,
    renderCell: (params: DataTableRenderCellParams<ChiTietDieuKienThanhToan>) => (
      <CellField
        name='ngay_gom_hd2'
        type='number'
        value={params.row.ngay_gom_hd2}
        onValueChange={(newValue: BanHangValue) =>
          params.row.uuid && onCellValueChange(params.row.uuid, 'ngay_gom_hd2', newValue)
        }
        commitOnBlur
      />
    )
  }
];
